/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import SafeAreaView from 'components/SafeAreaView';
import BreadCrumb from 'components/Breadcrumb';
import ImageAsyncComponent from 'components/ImageAsyncComponent';
import formatPaths from 'helpers/formatPaths';
import PropTypes from 'prop-types';

const DisplayList = ({ content, toDisplay }) => {
  const { pathname } = useLocation();
  const paths = formatPaths(pathname);

  return (
    <SafeAreaView>
      <div className="bg-light">
        <div className="container py-5">
          <div className="row justify-content-between">
            <h1 className="h4 mb-0">Liste {toDisplay}</h1>
            <BreadCrumb paths={paths} />
          </div>
        </div>
      </div>
      <div className="container space-top-1 space-top-md-2 space-bottom-2 space-bottom-lg-3">
        <div className="row justify-content-center">
          {content.map(o => (
            <div className="col-lg-2 col-sm-6 col-6 justify-content-center" key={o.searchKey}>
              <Link to={`/products${o.searchKey}`} key={o.name} className="text-muted h3 col-sm-3 mb-3 mb-sm-0">
                <>
                  <div className="mb-3">
                    <ImageAsyncComponent image={o.image} />
                    <span className="d-block h3 text-center pt-4">{o.name}</span>
                  </div>
                </>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </SafeAreaView>
  );
};

DisplayList.propTypes = {
  content: PropTypes.array,
  toDisplay: PropTypes.string,
};
export default DisplayList;
